import { ReactElement } from 'react';

import { useStoreActions } from '~/store/hooks';
import { IYearMonth } from '~/utils/date/date';
import { useApiRequest } from '~/hooks/api';
import { IMedicaidPlanClient } from '~/services/api/medicaidPlan/types';

import MonthRecord from './MonthRecord';

interface IArchivedPlanMonthProps {
  planId: number;
  client: IMedicaidPlanClient;
  selected: IYearMonth;
}

const ArchivedPlanMonth = ({ planId, client, selected }: IArchivedPlanMonthProps): ReactElement => {
  const { onGetArchivedPlanRecord } = useStoreActions(actions => actions.communityEngagement);

  const { isLoading, data: record } = useApiRequest(
    ({ signal }) =>
      onGetArchivedPlanRecord({
        ...client,
        year: selected.year,
        month: selected.month,
        medicaidPlanId: planId,
        signal,
      }),
    {
      initialLoading: true,
      dependencies: [client, planId, selected.year, selected.month],
    },
  );

  return <MonthRecord selected={selected} isLoading={isLoading} record={record} />;
};

export default ArchivedPlanMonth;
